import { APP_PERMISSIONS } from '@exam-management/permissions';
import { capitalize } from '@shared/utils';

// Predefined Role Names
const APP_ROLES = {
  ADMIN: 'Administrator',
};

// FIXME: Workaround for ordering app permissions
const APP_PERMISSIONS_DISPLAY_ORDER = [
  'task',
  'task.questionCreation',
  'task.questionReview',
  'task.qsetReview',
  'task.auditLog',
  'qbank',
  'qbank.dashboard',
  'qbank.question',
  'qbank.structure',
  'qbank.los',
  'qbank.setting',
  'qbank.auditLog',
  'exam',
  'exam.examinationCourse',
  'exam.qconfig',
  'exam.qset',
  'exam.auditLog',
  'setting',
  'setting.user',
  'setting.role',
  'setting.auditLog',
];

const APP_PERMISSIONS_NAME: Record<string, string> = {
  task: 'Task Management',
  'task.questionCreation': 'Question Creation',
  'task.questionReview': 'Question Review',
  'task.qsetReview': 'QSet Review',
  qbank: 'คลังข้อสอบ',
  'qbank.los': 'LOS',
  'qbank.dashboard': 'Dashboard',
  'qbank.question': 'Question List',
  'qbank.structure': 'Structure',
  'qbank.auditLog': 'Activity Log',
  'qbank.setting': 'Settings',
  exam: 'หลักสูตรทดสอบ',
  'exam.examinationCourse': 'Examination Course',
  'exam.qconfig': 'QConfig',
  'exam.qset': 'QSet',
  'exam.auditLog': 'Activity Log',
  setting: 'การตั้งค่า',
  'setting.user': 'User Management',
  'setting.role': 'Role & Permission',
  'setting.auditLog': 'Activity Log',
};

const generateDisplayName = (permissionKey: string) => {
  const [, category, action] = permissionKey.split(/[.-]/); // split by both '.' and '-'

  const categoryCapitalized = capitalize(category);
  const actionCapitalized = capitalize(action);

  return `${categoryCapitalized} ${actionCapitalized}`;
};

const APP_PERMISSIONS_DISPLAY_NAME = Object.fromEntries(
  Object.entries(APP_PERMISSIONS).flatMap(([, modulePerms]) =>
    Object.values(modulePerms).flatMap((category) =>
      Object.entries(category).map(([, value]) => [value, generateDisplayName(value)]),
    ),
  ),
);
export {
  APP_PERMISSIONS_DISPLAY_NAME,
  APP_PERMISSIONS_DISPLAY_ORDER,
  APP_PERMISSIONS_NAME,
  APP_ROLES,
};
